import {defineStore} from 'pinia'
import {useAssetsStore} from "@/stores/assets.js";
import {getFirstPage, onPage, onRowsUpdate} from "@/stores/_helpers.js";

export const useAssetsRecentlyViewedPageStore = defineStore('assetsRecentlyViewedPage', {
    state: () => ({
        data: undefined,
        totalRecords: 0,
        loading: true,
        params: {
            per_page: 20,
            page: 1,
            include: [
                'assetType',
                'devices.deviceModel',
                'devicesNeedingUpdate',
                'company',
                'rxSwins',
                'rxSwins.regulation',
            ],
        },
        pages: [
            10,
            20,
            50,
            100,
        ]
    }),
    getters: {
        getAssets: (state) => {
            return state.data?.data;
        },
        getFirstPage: (state) => {
            return getFirstPage(state.params)
        }
    },
    actions: {
        onPage($event) {
            onPage($event, this.params);
            this.loadData();
        },
        onRowsUpdate(rowCount) {
            onRowsUpdate(rowCount, this.params);
        },
        async loadData() {
            const assetsStore = useAssetsStore();
            this.loading = true;
            this.data = await assetsStore.indexRecentlyViewedAssets(this.params)
            this.totalRecords = this.data.total;
            this.loading = false;
        }
    },
});
